<template>
  <div>
    <v-btn
      v-if="certidaoNegativa == null"
      @click.native="showModalCertidaoNegativa()"
      dark
      small
      color="primary"
    >
      Upload CND Municipal
      <v-icon class="ml-1" icon elevation="2">mdi-upload</v-icon>
    </v-btn>
    <v-btn
      v-else
      small
      color="success"
      @click.native="showModalCertidaoNegativa()"
    >
      Certidão Negativa Municipal
      <v-icon class="ml-1" icon elevation="2">mdi-eye</v-icon>
    </v-btn>

    <v-dialog v-model="modalCertidaoNegativa" max-width="500px">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>
          <Lynx-Label label="Upload de Certidão Negativa Municipal" />
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col v-if="certidaoNegativa == null" cols="12">
                <Input-File
                  class="px-2"
                  text="Certidão Negativa Municipal"
                  ref="arquivoCertidaoNegativaInput"
                />
              </v-col>
              <v-col v-else cols="12">
                <v-btn
                  type="button"
                  elevation="10"
                  class="p-5"
                  @click.native="openFile(certidaoNegativa.arquivo)"
                >
                  <div class="row justify-between">
                    <span>{{ certidaoNegativa.arquivo.nome_original }}</span>
                    <v-icon>mdi-attachment</v-icon>
                  </div>
                </v-btn>
                <v-btn
                  class="ml-1"
                  fab
                  small
                  color="error"
                  @click.native="deleteCertidaoNegativa(certidaoNegativa.id)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="modalCertidaoNegativa = false"
          >
          Cancelar
          </v-btn>
          <v-btn
          v-if="certidaoNegativa == null"
            color="blue darken-1"
            text
            @click.native="confirmarUploadCertidaoNegativa"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  createCertidaoNegativaRequest,
  deleteCertidaoNegativaRequest,
} from "@/services/requests/certidaoNegativa";
import InputFile from "@/components/helpers/InputFile";
import { mapGetters } from "vuex";
export default {
  components: {
    InputFile,
  },
  props: {
    empresa: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modalCertidaoNegativa: false,
      loading: false,
      form: {
        file: null,
        empresa: this.empresa.id,
        motivo: null,
        tipo: "Municipal",
      },
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    certidaoNegativa() {
      return this.empresa.certidao_negativa_municipal;
    },
  },
  methods: {
    showModalCertidaoNegativa() {
      this.modalCertidaoNegativa = true;
    },

    confirmarUploadCertidaoNegativa() {
      if (!this.$refs.arquivoCertidaoNegativaInput.file) {
        this.$snack.error("Por favor, insira um arquivo antes de confirmar.");
        return;
      }
      this.modalCertidaoNegativa = false;

      //TODO: retirar os codigos comentados caso não for necessário o motivo 
      // será mantido por um tempo assim para ver se existe ou não essa necessidade
      this.$buefy.dialog.confirm({
        message: "Deseja realmente enviar a Certidão Negativa Municipal?",
        confirmText: "Enviar",
        cancelText: "Cancelar",
        type: "is-success",
          // hasInput: true,
          // inputAttrs: {
          //   placeholder: "Motivo",
          //   maxlength: 255,
          // },
          // trapFocus: true,
        // onConfirm: (value) => {
        onConfirm: () => {
          // if (value) {
            // this.form.motivo = value;
            this.uploadCertidaoNegativa();
          // } else {
            // this.$buefy.toast.open({
            //   message: "Por favor, insira o motivo antes de confirmar.",
            //   type: "is-danger",
            // });
          // }
        },
        onCancel: () => {
          this.modalCertidaoNegativa = true;
          this.$snack.error("Envio de Certidão Negativa Municipal cancelado.");
        },
      });
    },

    async uploadCertidaoNegativa() {
      this.loading = true;
      this.modalCertidaoNegativa = true;
      this.form.file = await this.$refs.arquivoCertidaoNegativaInput.submit();

      await createCertidaoNegativaRequest(this.form)
        .then((res) => {
          this.$snack.success(res.data.msg);
          this.$emit("fetchEmpresasAlvarasTaxa");
        })
        .catch((error) => {
          const errors = Object.values(error.response.data.errors);
          const message = errors
            .map((item) => item.map((error) => `<li>${error}</li>`).join(""))
            .join("");

          this.$buefy.dialog.alert({
            title: "Não foi possível enviar a Certidão Negativa Municipal",
            message: `<ul>${message}</ul>`,
            type: "is-danger",
          });
        })
        .finally(() => {
              this.loading = false;
              this.modalCertidaoNegativa = false;
            });
    },
    openFile(arquivo) {
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${arquivo.id}/open?token=${this.getToken}`
      );
    },
    async deleteCertidaoNegativa(id) {
      this.modalCertidaoNegativa = false;
      this.$buefy.dialog.confirm({
        message: "Deseja realmente excluir a Certidão Negativa Municipal?",
        confirmText: "Excluir",
        cancelText: "Cancelar",
        type: "is-danger",
        onConfirm: async () => {
          this.modalCertidaoNegativa = true;

          this.loading = true;
          await deleteCertidaoNegativaRequest(id)
            .then((res) => {
              this.$snack.success(res.data.msg);
              this.$emit("fetchEmpresasAlvarasTaxa");
            })
            .catch(() => {
              this.$snack.error(
                "Não foi possível excluir a Certidão Negativa Municipal."
              );
            })
            .finally(() => {
              this.loading = false;
              this.modalCertidaoNegativa = false;
            });
            
        },
        onCancel: () => {
          this.modalCertidaoNegativa = true;
          this.$snack.error(
            "Exclusão de Certidão Negativa Municipal cancelada."
          );
        },
      });
    },
  },
};
</script>